enum BatchType {
    Unknown,
    Complete,
    Incremental,
    StatusUpdate,
    CompleteSubset,
}

export default BatchType;
